import { ButtonClipboard } from '../ui/ButtonClipboard'
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroupTextarea,
} from '../ui/input-group'

export function ErrorViewer({
  error,
  meta = {},
}: {
  error: Error
  meta?: Record<string, string>
}) {
  const debugMeta = Object.entries(meta).map(
    ([key, value]) => `${key}: ${value}`,
  )

  const debugInfo = [
    `${error.name}: ${error.message}`,
    `URL: ${String(window.location)}`,
    `Time: ${String(new Date())}`,
    ...debugMeta,
    `Stack trace: ${error.stack}`,
  ].join('\n\n')

  return (
    <InputGroup className="overflow-hidden">
      <InputGroupAddon
        align="block-start"
        className="border-b border-border"
      >
        <InputGroupText className="mr-auto">Error log</InputGroupText>
        <ButtonClipboard
          variant="ghost"
          value={debugInfo}
        >
          Copy log
        </ButtonClipboard>
      </InputGroupAddon>

      <InputGroupTextarea
        name="log"
        value={debugInfo}
        wrap="off"
        rows={8}
        readOnly
        className="field-sizing-fixed px-4 font-mono text-xs bg-background/50 text-muted-foreground"
      />
    </InputGroup>
  )
}
